// =============================================================================
// The FAQ accordion.
//
// Opening and closing is CSS — `max-height` on `.faq-a`, driven by `.is-open`
// on the item — so every answer is in the HTML whether or not this runs. What
// CSS cannot do is keep `aria-expanded` honest, which is the one job here: a
// button that reports "collapsed" while its answer is on screen misleads an
// assistive technology user worse than no state at all.
// =============================================================================

export default function initFaq() {
	// Delegated on the document rather than bound per question: one listener
	// regardless of how many answers a page carries, and it keeps working if the
	// block is rendered again after this has run.
	document.addEventListener("click", (event) => {
		const button = event.target.closest("[data-faq-toggle]");
		if (!button) {
			return;
		}

		const item = button.closest(".faq-item");
		if (!item) {
			return;
		}

		const isOpen = item.classList.toggle("is-open");
		button.setAttribute("aria-expanded", isOpen ? "true" : "false");
	});
}
